import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { TaskInput } from '../../types'
import {
  Primary12SemiBold,
  CustomerLogo,
  Box
} from '@sequencehq/core-components'
import { getLogoSrc } from 'Customer/index'

export const QuoteReviewListItemContent = ({
  taskId,
  isSelected,
  hideUnreadIndicator,
  onClick
}: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const { manualTask, isUnread, statusIcon, preload } =
    useManualTaskListItemContentToolkit<TaskInput>({
      taskId
    })

  if (!manualTask?.input) {
    return <InboxListItemContent.Loading />
  }

  return (
    <InboxListItemContent
      isSelected={isSelected}
      isUnread={hideUnreadIndicator ? undefined : isUnread}
      onClick={onClick}
      onPreload={preload}
      title={`${manualTask?.input.quote.quoteNumber} ${manualTask?.input.quote.title}`}
      description={
        <>
          Quote sent for approval by{' '}
          <Box as="span" {...Primary12SemiBold}>
            {manualTask?.input.requestor.email}
          </Box>
        </>
      }
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <CustomerLogo
            src={getLogoSrc(manualTask.input.customer)}
            size={24}
            fallbackSize={16}
          />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
